import { HubModeSchema } from '@/lib/facts/vocabularies'

/*
 * The mode hub's address: `/{locale}/{mode}-tickets/`, one per mode a hub exists in. The
 * segment is matched whole against the closed mode list; whether the hub exists is the
 * mode-hub model's answer (→ invariants.md#url-validity-is-the-stores-answer).
 */

export const HUB_MODES = HubModeSchema.options

export type HubMode = (typeof HUB_MODES)[number]

const TICKETS_SUFFIX = '-tickets'

/** `bus-tickets` → `bus`; `undefined` for a segment that names no hub. */
export function hubModeOfSegment(segment: string): HubMode | undefined {
    return HUB_MODES.find((mode) => segment === `${mode}${TICKETS_SUFFIX}`)
}

/** The hub's slug as the page type serves it: `/bus-tickets`. */
export const hubSlug = (mode: HubMode): string => `/${mode}${TICKETS_SUFFIX}`

/** `/bus-tickets` → `bus`; `undefined` for any other slug. */
export const hubModeOfSlug = (slug: string): HubMode | undefined =>
    slug.startsWith('/') ? hubModeOfSegment(slug.slice(1)) : undefined
